// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__CzcTD","left":"InfoRow_left__B4Qx_"};